import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import vw from 'styles/utils';

function ImageThumbnail(props) {
  const { src, title, onClick } = props;

  return (
    <Root onClick={onClick}>
      <img src={src} alt="thumbnail"/>
      <p>{title}</p>
    </Root>
  )
}

ImageThumbnail.propTypes = {
  src: PropTypes.any,
  title: PropTypes.string,
  onClick: PropTypes.func
}

const Root = styled.div`
  cursor: pointer;

  ${vw('padding', 10)}

  &:hover {
    > p {
      color: #3398DC;
    }
  }

  > img {
    width: 100%;
    height: auto;
    
    ${vw('margin-bottom', 10)}
  }

  > p {
    font-family: 'Noto Sans TC';
    font-style: normal;
    font-weight: 500;
    text-align: center;
    color: #252525;
    transition: all 0.25s;

    ${vw('font-size', 10, 14)}
    ${vw('line-height', 18, 25)}
  }
`;

export default ImageThumbnail
